import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Lost from "./pages/lost";
import Home from "./pages/home";
import About from "./pages/about";
import Games from "./pages/games";
import Contact from "./pages/contact";
import Rental from "./pages/rental";
import Technician from "./pages/technician";
import Product from './pages/product';
import Unavailable from "./pages/unavailable";



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/games" element={<Games />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/rental" element={<Rental />} />
        <Route path="/technician" element={<Technician />} />
        <Route path="/product" element={<Product />} />
        <Route path="/unavailable" element={<Unavailable />} />
        <Route path="*" element={<Lost />} />
      </Routes>
    </Router>
  );
}

export default App;
